<template>
  <hm-content title="">
    <div
      class="mt20"
      style="padding-left:30%;padding-bottom:20px;border-bottom:1px solid #999"
    >
      1.会员卡补卡
      <div>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry"
          type="datetimerange"
          align="right"
          start-placeholder="请选择补卡时间段"
          end-placeholder="请选择补卡时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :disabled="searchCondition.memberMobile !== ''"
          size="small"
          class="mr10"
        ></el-date-picker>
      </div>

      <div style="marginTop:30px">
        <el-input
          clearable
          style="width:250px"
          class="mr10"
          :disabled="!!searchCondition.createTimeArry"
          v-model="searchCondition.memberMobile"
          size="small"
          placeholder="请输入手机号"
        ></el-input>
        <el-checkbox v-model="isDirectWriteErp">直接写入ERP(仅供测试)</el-checkbox>
      </div>

      <div style="marginTop:30px">
        <el-button type="primary" size="small" @click="search">补 卡</el-button>
      </div>
    </div>
    <div class="mt20" style="height:30vh;margin-left:30%">
      2.PLUS会员补卡
      <div>
        <el-date-picker
          clearable
          :default-time="['00:00:00', '23:59:59']"
          v-model="searchCondition.createTimeArry1"
          type="datetimerange"
          align="right"
          start-placeholder="请选择补卡时间段"
          end-placeholder="请选择补卡时间段"
          value-format="yyyy-MM-dd HH:mm:ss"
          :disabled="searchCondition.memberMobile !== ''"
          size="small"
          class="mr10"
        ></el-date-picker>
      </div>

      <div style="marginTop:30px">
        <el-input
          clearable
          style="width:250px"
          class="mr10"
          :disabled="!!searchCondition.createTimeArry1"
          v-model="searchCondition.memberMobile1"
          size="small"
          placeholder="请输入手机号"
        ></el-input>
      </div>

      <div style="marginTop:30px">
        <el-button type="primary" size="small" @click="search1"
          >补 卡</el-button
        >
      </div>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      title="补卡失败手机号"
      :visible.sync="dialogVisible"
    >
      <el-table stripe border :data="errList" size="small">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="失败手机号"
        >
          <template slot-scope="scope">
            {{ scope.row }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
      isDirectWriteErp: false,
      errList: [],
      searchCondition: {
        memberMobile: "",
        // createTimeArry: "",
        memberMobile1: "",
        directWriteErp:""
        // createTimeArry1: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    async search1() {
      const searchCondition = {};
      

      searchCondition.cardStartTime =
        this.searchCondition.createTimeArry1 &&
        this.searchCondition.createTimeArry1.length > 0
          ? this.searchCondition.createTimeArry1[0]
          : null;
      searchCondition.cardEndTime =
        this.searchCondition.createTimeArry1 &&
        this.searchCondition.createTimeArry1.length > 0
          ? this.searchCondition.createTimeArry1[1]
          : null;
      searchCondition.mobile = this.searchCondition.memberMobile1;
      
      
      const { code, result } = await this.$store.dispatch(
        "memberRegisterPlus",
        searchCondition
      );
      if (code === "0") {
        this.$message({
          message: "补卡成功!",
          type: "success"
        });
        if (result.length) {
          this.dialogVisible = true;
          this.errList = result;
        }
      }
    },
    async search() {
      if(this.isDirectWriteErp){
        this.searchCondition.directWriteErp = 'yes';
        
      }else{
        this.searchCondition.directWriteErp = 'no';
      }
      console.log("this.isDirectWriteErp:",this.isDirectWriteErp);
      console.log("this.searchCondition.directWriteErp:",this.searchCondition.directWriteErp);
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      console.log("searchCondition:",searchCondition);
      searchCondition.createTimeStart =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[0]
          : null;
      searchCondition.createTimeEnd =
        this.searchCondition.createTimeArry &&
        this.searchCondition.createTimeArry.length > 0
          ? this.searchCondition.createTimeArry[1]
          : null;
      const { code, result } = await this.$store.dispatch(
        "memberRegister",
        searchCondition
      );
      if (code === "0") {
        this.$message({
          message: "补卡成功!",
          type: "success"
        });
        if (result.length) {
          this.dialogVisible = true;
          this.errList = result;
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
